var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.screenshot)?_c('preview-phone',[_c('router-view',{staticClass:"screenshot-size"})],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }